import {Role, RolePermissions} from './../../core/model/role';
import {RolePermissionCell} from '../models/roles-table.model';

type UnknownPermission = unknown;

export function isPermissionCell(obj: UnknownPermission): obj is RolePermissionCell {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'name' in obj &&
    'description' in obj &&
    'active' in obj &&
    typeof (obj as Record<string, unknown>).name === 'string' &&
    typeof (obj as Record<string, unknown>).description === 'string' &&
    typeof (obj as Record<string, unknown>).active === 'boolean'
  );
}

export type UpdateRolePermissionsProps = {
  permKey: string;
  role: Role;
  checked: boolean;
};

export function updateRolePermissions(props: UpdateRolePermissionsProps) {
  const {permKey, role, checked} = props;
  // used to traverse nested permissions
  const keys = permKey.split('.');
  let perm: unknown = role.permissions;
  let parentPerm: unknown = null;

  for (let i = 0; i < keys.length; i++) {
    if (typeof perm !== 'object' || perm === null || !(keys[i] in perm)) return;
    if (i === keys.length - 1) {
      const lastPerm = (perm as Record<string, unknown>)[keys[i]];
      if (isPermissionCell(lastPerm)) {
        lastPerm.active = checked;
      }
    } else {
      parentPerm = perm;
      perm = (perm as Record<string, unknown>)[keys[i]];
    }
  }

  const permsPayload: RolePermissions = (keys.length > 1 ? parentPerm : perm) as RolePermissions;
  const rolePayload: Role = {
    ...role,
    permissions: permsPayload,
  };

  return rolePayload;
}
